import React from 'react'
import { useRegisterForm } from './useRegisterForm'
import { RegisterFormView } from './RegisterFormView'

export const RegisterForm: React.FC = () => {
  const props = useRegisterForm()
  return <RegisterFormView {...props} />
}
RegisterForm.displayName = 'RegisterForm'

export default RegisterForm
